import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarTurno from "./AgregarTurno/AgregarTurno";
import EditarTurno from "./EditarTurno/EditarTurno";
import { secondsToHms } from "../../../Components/TimeConvertions";

moment.locale("es");

class Turnos extends Component {
    tableRef = null;
    state = {
        todasTurnos: [],
        loading: false,
        valor: 1,
        modalAgregarTurno: false,
        modalEditarTurno: false,
        modalEditarTurnoId: null,
    };
    consultarTurnos(params) {
        this.setState({ loading: true });
        axios
            .post(
                "turnos/selectTodasTurnos",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasTurnos: [] });
                } else {
                    this.setState({
                        todasTurnos: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarTurno(value) {
        this.setState({ loading: true });
        axios
            .post(
                "turnos/deshabilitarTurno",
                { turnoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Turno deshabilitado");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarTurno(value) {
        this.setState({ loading: true });
        axios
            .post(
                "turnos/habilitarTurno",
                { turnoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Turno habilitado");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarTurno() {
        this.setState({ modalAgregarTurno: true });
    }
    cerrarAgregarTurno() {
        this.setState({ modalAgregarTurno: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    editarTurno(id) {
        this.setState({ modalEditarTurno: true, modalEditarTurnoId: id });
    }
    cerrarEditarTurno() {
        this.setState({ modalEditarTurno: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value,record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "13%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "18%",
            },
            {
                title: "Entrada",
                dataIndex: "entradaSeg",
                key: "entradaSeg",
                render: (value) => {
                    return secondsToHms(value)?.format("HH:mm:ss");
                },
                width: "18%",
            },
            {
                title: "Salida",
                dataIndex: "salidaSeg",
                key: "salidaSeg",
                render: (value) => {
                    return secondsToHms(value)?.format("HH:mm:ss");
                },
                width: "18%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (this.props.permisoEditarTurno) {
                        buttons.push(
                            <Tooltip
                                title="Editar Turno"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    key={`editar-${record._id}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarTurno(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (this.props.permisoDeshabilitarTurno) {
                        if (record.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    key={`deshabilitar-${record._id}`}
                                    title="¿Seguro que quieres deshabilitar este turno?"
                                    onConfirm={() => this.deshabilitarTurno(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Deshabilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${record._id}`}
                                    title="¿Seguro que quieres habilitar este turno?"
                                    onConfirm={() => this.habilitarTurno(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Habilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Turnos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            {this.props.permisoAgregarTurno && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarTurno"
                                    onClick={this.agregarTurno.bind(this)}
                                >
                                    Agregar Turno
                                </ButtonItem>
                            )}
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarTurnos.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasTurnos}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"turnos" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarTurno) {
                                this.editarTurno(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                <AgregarTurno
                    visible={this.state.modalAgregarTurno}
                    cerrarAgregarTurno={this.cerrarAgregarTurno.bind(this)}
                />
                <EditarTurno
                    visible={this.state.modalEditarTurno}
                    turnoId={this.state.modalEditarTurnoId}
                    cerrarEditarTurno={this.cerrarEditarTurno.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarTurno: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021a67899dda241377cf1")?.activado,
        permisoEditarTurno: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021b27899dda241377cf2")?.activado,
        permisoDeshabilitarTurno: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021c27899dda241377cf3")?.activado,
    };
};

export default connect(mapStateToProps)(Turnos);
